export const getFullName = (firstName: string, lastName: string): string => {
    const fullName: string = `${firstName} ${lastName}`;
    return fullName;
};

export const getCurrentAge = (birthDateString: string, timeZone: string): number => {
    const bornDate: Date = new Date(new Date(birthDateString).toLocaleString('en-US', { timeZone }));
    const currentDate: Date = new Date(new Date().toLocaleString('en-US', { timeZone }));

    let calculatedAge: number = currentDate.getFullYear() - bornDate.getFullYear();
    const monthDiff: number = currentDate.getMonth() - bornDate.getMonth();

    // Decrease the age by 1 if the birthday hasn't occurred yet this year
    if (
        monthDiff === 0 && 
        currentDate.getDate() < bornDate.getDate()
    ) {
        calculatedAge--;
    }

    return calculatedAge;
};